<template>
  <div class="">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
    >
      <el-form-item label="内容">
        <el-input v-model="form.content" />
      </el-form-item>

      <el-form-item label="配置">
        <el-select v-model="form.config_id" placeholder="请选择">
          <el-option
            v-for="item in configures"
            :key="item.id"
            :label="item.id"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >立即创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { configurationList } from '@/api/enterpriseWeChatCustomerService'
export default {
  props: {
    currentItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        config_id: null, // 配置
        content: null // 内容
      },
      configures: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    onSubmit() {
      this.judge() && this.$emit('determine', this.form)
    },

    async init() {
      const data = await configurationList()
      this.configures = data.data.list
    },

    judge() {
      let text = null
      if (!this.form.config_id) {
        text = '请选择配置'
      } else if (!this.form.content) {
        text = '请输入内容'
      }

      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    }

  }
}
</script>

<style scoped>
.erBox {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  cursor: pointer;
  position: relative;
}

.erBox::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 50px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox::after {
  content: '';
  position: absolute;
  width: 50px;
  height: 1px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox:hover{
   border-color: rgb(7, 123, 201);
}

.erBox:hover::after,.erBox:hover::before{
   background-color: rgb(7, 123, 201);
}

.file{
  display: none;
}

.imgBox{
   width: 100px;
   height: 100px;
   position: relative;
}

.imgBox:hover span{
   display: inline-block !important;
}

.imgBox span{
  width: 100%;
  height: 100%;
  background-color: rgba(200, 200, 200, 0.5);
  position: absolute;
  z-index: 11;
  left: 0px;
  display: none;
}

.myi{
    cursor: pointer;
    font-size: 25px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
</style>
